import { render, staticRenderFns } from "./maizePic.vue?vue&type=template&id=adfbd096&scoped=true&"
import script from "./maizePic.vue?vue&type=script&lang=js&"
export * from "./maizePic.vue?vue&type=script&lang=js&"
import style0 from "./maizePic.vue?vue&type=style&index=0&id=adfbd096&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfbd096",
  null
  
)

export default component.exports